export default Object.freeze({
  FormFieldAttachment: 'form-field-attachment',
  GeneratedDocument: 'generated-document',
  VariableAttachment: 'variable-attachment',
});
